import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'common-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
